import React, { useState, useEffect } from 'react'
import './Auth.css'
// import { SignUpModeContext } from '../../../Context/SignupModeContext'
import { useLocation, useNavigate } from "react-router-dom"
import LoginForm from '../loginForm/LoginForm'
import MainPanel from '../../panels/MainPanel'
// import loginImage from '../../Images/loginImage.svg'
import loginImageOne from '../../Images/loginImage1.jpg'
import FlexComponent from '../FlexComponent'
import breadcrumbsLogo from '../../Images/Breadcrumb_logo.png'
import LoginFormWithoutOtp from '../loginForm/LoginFormWithoutOtp'

function Auth() {

  // console.log("env", process.env.REACT_APP_LOCAL_APP);

  return (
    <div className='loginPage' style={{ background: "black" }} >
      <FlexComponent className="loginContainer" >
        <div className='loginFormDiv' style={{ height: '50%', width: "50%" }}>
          {(process.env.REACT_APP_LOCAL_APP && !window.location.href.includes("test.bcrumbs.com")) ? <LoginFormWithoutOtp/> : <LoginForm />}
          {/* <LoginForm /> */}
        </div>
        <div style={{ backgroundImage: `url(${loginImageOne})`, width: "50%", backgroundPosition: "top", backgroundSize: "cover" }} className="container1" ></div>
      </FlexComponent>
      <div className='glassBox' style={{ position: "absolute", height: "70px", top: 40, left: "8%",  width: "80vw" }} >
      </div>
      <div style={{ position: "absolute", paddingLeft: "1rem", fontSize: "20px", filter: "blur(0px)", color: "white", top: 60, left: "8%", }} >
        <img src={breadcrumbsLogo} style={{ height: "30px" }} alt="" />
      </div>
    </div>

  )
}

export default Auth